import React from "react";
import FieldTimeReported from "../../../time-spent";



type Props = {
    onSubmit: callback
    field       : FieldTimeReported
}
export default function HoursPreset(props:Props) {

    if (!props.field.presetHours) return null


    const onValueChange = (value: number) => {
        props.onSubmit(value)
    }

    return (
        <div className="m-t-10 flex-column-left-top">
            <div className="ui5-txt-no-accent-tiny">Hours</div>
            <div className="flex-row-left-center m-t-10">
                {props.field.presetHours.map((obj, key) => {
                    const classes = Classes("ui5-popover-preset-value", {
                        selected: false //app.model.reportedTimeMinutes === obj.value
                    });
                    return (
                        <div key={key} className={classes} onClick={() => onValueChange(obj.value as number)}>
                            {obj.label}
                        </div>
                    )
                })}
            </div>
        </div>
    );


}



